import React from 'react';
import { MBUrgentBannerComponent } from './banner';
import { MBUrgentModalComponent } from './modal';

export interface MBUrgentBannerWithModalProps {
  count: number;
  autoShowModal?: boolean;
  onRemoveSendAsUrgent(): void;
}

export function MBUrgentBannerWithModal({
  count,
  onRemoveSendAsUrgent,
  autoShowModal = false,
}: MBUrgentBannerWithModalProps) {
  const [modalVisible, setModalVisible] = React.useState(autoShowModal);
  const showModal = React.useCallback(() => setModalVisible(true), []);
  const hideModal = React.useCallback(() => setModalVisible(false), []);

  return (
    <>
      <MBUrgentBannerComponent
        count={count}
        onPress={showModal}
        onRemoveSendAsUrgent={onRemoveSendAsUrgent}
      />
      <MBUrgentModalComponent
        count={count}
        visible={modalVisible}
        onClose={hideModal}
        onRemoveSendAsUrgent={onRemoveSendAsUrgent}
      />
    </>
  );
}
